import MarketShare from "assets/img/createQuery/market_share.svg";
import CamaignEffect from "assets/img/createQuery/campaign_effect.svg";
import ClinicalMarket from "assets/img/createQuery/clinical_market_share.svg";
import ClinicalVolume from "assets/img/createQuery/clinical_volume.svg";
import PopulationTracker from "assets/img/createQuery/population_tracker.svg";
import ShareCare from "assets/img/createQuery/share_care.svg";
import POSCountry from "assets/img/createQuery/place_of_service_country.svg";
import PlaceOfService from "assets/img/createQuery/place_of_service.svg";
import Countrylevel from "assets/img/createQuery/country_level.svg";
import Billingreport from "assets/img/createQuery/billing_report.svg";
import TrendedPOC from "assets/img/createQuery/trended_poc.svg";

export const getIcon = item => {
  const { id } = item;
  switch (id) {
    case "f128b036-62bc-403d-b0cb-596f22297d36":
      return {
        icon: MarketShare,
        color: 'var(--marketShare)'
      };
    case "f891fb88-95e5-4358-9dc7-c49848a0ccd8":
      return {
        icon: ClinicalMarket,
        color: 'var(--clinicalMarket)'
      };
    case "320ff5ec-097e-4371-82a4-e3cc2623dc53":
      return {
        icon: ShareCare,
        color: 'var(--shareCare)'
      };
    case "8ad8fedc-a1cd-4e0b-ba7a-30d59e6e5f98":
      return {
        icon: PopulationTracker,
        color: 'var(--populationTracker)'
      };
    case "4c6dc426-0ba0-4cee-986f-a6800bc9c666":
      return {
        icon: CamaignEffect,
        color: 'var(--camaignEffect)'
      };
    case "bc41672f-b834-4826-864e-549c4586edc6":
      return {
        icon: ClinicalVolume,
        color: 'var(--clinicalVolume)'
      };
    case "19e62af0-0c09-4042-bfb5-5cefe113f144":
      return {
        icon: POSCountry,
        color: 'var(--clinicalVolume)'
      };
    case "a5b8b2d4-93c9-47a0-b132-0fed4f6d2289":
      return {
        icon: Countrylevel,
        color: 'var(--countrylevel)'
      };
    case "4c526dbe-10dd-49bb-a444-04a0adca08cc":
      return {
        icon: PlaceOfService,
        color: 'var(--placeOfService)'
      };
    case "246c5d26-7850-4101-8944-68a3e3119ba3":
      return {
        icon: TrendedPOC,
        color: 'var(--trendedPOC)'
      };
    case "2c216183-eb2d-4921-ad24-c9bb3556f428":
      return {
        icon: Billingreport,
        color: 'var(--billingreport)'
      };
    default:
      return {
        icon: MarketShare,
        color: 'var(--MarketShare)'
      };
  }
};
